const envFlag = (value: string | undefined, fallback = false) => {
  if (value === undefined) return fallback;
  return value.toLowerCase() === 'true';
};

export const DISPLAY_CONFIG = {
  brandName: 'Slope',
  tagline: 'Ride the line. Beat the fall.',
  locale: 'en-ZA',
  // Play credits only: never a real currency symbol (App Review guideline 5.3; constitution VI).
  currencySymbol: '❄',
  // Always shown. The product is free to play; "demo"/"pitch" wording is avoided because
  // App Review rejects apps presented as demos or trials (guideline 2.2).
  freePlayLabel: 'Free play credits · No cash value · Not redeemable',
  showDevTools: process.env.NODE_ENV === 'development' && envFlag(process.env.REACT_APP_SHOW_DEV_TOOLS, true),
} as const;
